import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import msalConfig from './authConfig';
import { RouterProvider } from 'react-router-dom';
import getRouter from './router';
import styles from './index.module.scss';

const rootElement = document.getElementById('root');
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    const msalInstance = new PublicClientApplication(msalConfig);
    root.render(
        <div className={styles.root}>
            <React.StrictMode>
                <MsalProvider instance={msalInstance}>
                    <RouterProvider
                        router={getRouter('/Home/React', msalInstance)}
                        fallbackElement={undefined}
                        future={undefined}
                    />
                </MsalProvider>
            </React.StrictMode>
        </div>
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
} else {
    throw new Error("failed to find root element");
}
